/* eslint-disable */
import React from 'react'

export default function PieLegend({ settings, radiusScale }) {
    let domain = radiusScale.domain().reverse()
    let domainTotal = 0

    // Get total sum of domain... if it equals 2 it has 1,1 in array which we don't want showing up on the legend
    for (let i = 0; i < domain.length; i++) {
        domainTotal += domain[i]
    }

    if (domainTotal == 2) {
        domain = [1]
    }

    let translate = [settings.vizWidth * 1.02, settings.vizHeight * 0.9]
    if (settings.orientation === 'portrait') {
        translate = [settings.vizWidth / 1.4, settings.vizWidth * 1.05]
    }

    return (
        <g
            key="pieLegend"
            id="pieLegend"
            transform={`translate(${[translate]})`}
        >
            {domain.map((d, i) => (
                <g key={`g_${i}`}>
                    <circle
                        key={`pieLegendPath_${i}`}
                        r={radiusScale(d) - settings.vizWidth * 0.014}
                        transform={`translate(0, ${i * 28})`}
                        fill="none"
                        stroke="#000"
                    />
                    <text
                        key={`pieLegendText_${i}`}
                        className="legend"
                        dy="4"
                        transform={`translate(20, ${i * 28})`}
                        fill="#000"
                        style={{ fontSize: `1rem` }}
                    >
                        {d} {d === 1 ? 'Pitch' : 'Pitches'}
                    </text>
                </g>
            ))}
        </g>
    )
}
